import { Info } from "lucide-react";

/* Centralized pricing disclaimer used across:
   - Build OS modal (Step 1, 4, success)
   - All form modals (BookDemo, Enterprise, EMR pages, etc.)
   - The /build page
   Keeps the message identical everywhere so customers can never be confused
   about what they're committing to. */

export const PRICING_DISCLAIMER_LINES = {
  short:
    "Base $297 / $497 per location (fixed) · Add-on pricing custom — finalized after a 20-min discovery call.",
  long:
    "Your base subscription is fixed at $297 (Clinic Hub) or $497 (Clinic Hub+) per location. Add-ons are quoted separately based on your specialty and consumption, and provided after a 20-minute discovery call. No surprises.",
};

/**
 * PricingNote — inline note block.
 * @param {"info"|"warning"|"plain"} tone
 * @param {"short"|"long"} variant
 */
export const PricingNote = ({ tone = "info", variant = "short", className = "" }) => {
  const palette =
    tone === "warning"
      ? "border-amber-500/30 bg-amber-500/[0.06] text-amber-700 dark:text-amber-300"
      : tone === "plain"
        ? "border-border bg-secondary/40 text-foreground/80"
        : "border-blue-500/25 bg-blue-500/[0.05] text-foreground/85";
  const iconColor =
    tone === "warning" ? "text-amber-500" : tone === "plain" ? "text-muted-foreground" : "text-blue-500";

  return (
    <div
      data-testid="pricing-note"
      className={`flex items-start gap-2.5 rounded-xl border p-3 text-[12px] leading-snug ${palette} ${className}`}
    >
      <Info className={`mt-0.5 h-3.5 w-3.5 flex-none ${iconColor}`} />
      <p>
        <span className="font-bold">Heads up — pricing.</span>{" "}
        <span className="opacity-90">{PRICING_DISCLAIMER_LINES[variant]}</span>
      </p>
    </div>
  );
};
